import { FormattedMessage } from 'react-intl'

import { Button } from '@gto/ui/button'
import { colors, gradients, radius } from '@gto/ui/theme/design-tokens'
import { Typography } from '@gto/ui/typography'

import { AbsoluteSuitsOnCorners } from '@/components/absolute-suits-on-corners'
import { useSupportLinks } from '@/components/support-links'

export const ContactUs = () => {
  return (
    <section
      className="relative mt-12 flex flex-col gap-16 px-0 py-12 sm:gap-12 sm:px-4"
      style={{
        border: `1px solid ${colors.divider}`,
        borderRadius: radius.med,
        background: gradients.primary.horizontal(0.001, 0.002),
      }}
    >
      <AbsoluteSuitsOnCorners top={-8} />
      <Typography
        className="text-center"
        color="primary"
        component="h2"
        variant="h3"
      >
        <FormattedMessage id="home.contactUs.title" />
      </Typography>
      <Typography
        className="text-center text-[28px] font-semibold sm:text-[20px]"
        component="h3"
        variant="h4"
      >
        <FormattedMessage id="home.contactUs.description" />
      </Typography>

      <div className="m-0 flex w-auto flex-row items-center justify-center gap-6 sm:mx-auto sm:w-full sm:flex-col sm:items-stretch">
        {useSupportLinks().map((link) => (
          <Button
            key={link.gaTag}
            aria-label={link['aria-label']}
            color="secondary"
            href={link.href}
            rel={link.rel}
            size="large"
            startIcon={link.icon}
            target={link.target}
            variant="contained"
          >
            {link.label}
          </Button>
        ))}
      </div>
    </section>
  )
}
